import { useCallback } from "react";

import { useNavigate } from "..";
import { INotification } from "../../store/types";
import { NotificationHandlerType } from "./use-click-handler";

export function useClassificationHook(): NotificationHandlerType {
  const navigate = useNavigate();

  return useCallback(
    async ({ components }: INotification) => {
      navigate({
        route: "workspaceAllFiles",
        params: { deal_id: components.deal_id }
      });
    },
    [navigate]
  );
}
